import React from 'react'
import CommonText from '../common/CommonText'
import ReceipeList from './ReceipeList'

const ReceipeBlock = ({ receipe, onChange, onClick, readOnly, isClose }) => {
  const titleStyle = {
    fontWeight: 700,
    fontSize: '20px',
    marginBottom: '20px',
  }
  return (
    <>
      <CommonText tag="div" style={{ ...titleStyle }}>
        레시피 순서
      </CommonText>
      <ReceipeList
        receipe={receipe}
        onChange={onChange}
        onClcik={onClick}
        readOnly={readOnly}
        isClose={isClose}
      />
    </>
  )
}

export default ReceipeBlock
